import * as React from 'react';
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import UpdateIcon from '@mui/icons-material/Update';
import Tooltip from '@mui/material/Tooltip';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import FormControl from '@mui/material/FormControl';
import CheckIcon from '@mui/icons-material/Check';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import RefreshIcon from '@mui/icons-material/Refresh';
import Modal from 'react-bootstrap/Modal';
import DownloadIcon from '@mui/icons-material/Download';
import Dropdown from 'react-bootstrap/Dropdown';
import RevisionQuote from '../revisequote';
import { useParams } from 'react-router-dom';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import { postRequest, deleteRequest, getRequest } from '../../../lib/api';
import BreadcrumbsWrapper from '../../../components/breadcrumbs';
import { AuthContext } from '../../../authContext/context';
import Swal from 'sweetalert2';
import Notes from '../Notes/note';
import jsPDF from 'jspdf';

function MyVerticallyCenteredModal({ show, onHide, quoteData, leadData }) {
  const generatePDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;

    // Header
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text(`Quote for Lasting Powers Of Attorney #${leadData?.lead_id || 'N/A'}`, 10, 20);

    // Subheading with legal fees total
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    const totalText = `Legal Fees from My Law Matters of £${(quoteData?.totals?.total?.gross || quoteData?.totalCost || 0).toFixed(2)} inc. VAT`;
    doc.text(totalText, 10, 35);

    // Thank you message
    doc.text('Thank you for choosing My Law Matters for your Lasting Powers Of Attorney needs.', 10, 50);

    // Create manual table
    let yPosition = 65;

    // Table header
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.rect(10, yPosition, 60, 8); // Description column
    doc.rect(70, yPosition, 30, 8); // Net column
    doc.rect(100, yPosition, 30, 8); // VAT column
    doc.rect(130, yPosition, 40, 8); // Total column

    doc.text('Description', 12, yPosition + 5);
    doc.text('Net', 82, yPosition + 5);
    doc.text('VAT', 112, yPosition + 5);
    doc.text('Total', 142, yPosition + 5);

    yPosition += 8;

    // Table data rows
    doc.setFont('helvetica', 'normal');
    const legalFee = parseFloat(quoteData?.totals?.total?.net || quoteData?.mlmLegalCost || 0);
    const vat = parseFloat(quoteData?.totals?.total?.vat || quoteData?.vat || 0);
    const legalTotal = parseFloat(quoteData?.totals?.total?.gross || quoteData?.totalCost || 0);

    // Legal Fee row
    doc.rect(10, yPosition, 60, 8);
    doc.rect(70, yPosition, 30, 8);
    doc.rect(100, yPosition, 30, 8);
    doc.rect(130, yPosition, 40, 8);

    doc.text('Legal Fees', 12, yPosition + 5);
    doc.text(`£${legalFee.toFixed(2)}`, 72, yPosition + 5);
    doc.text(`£${vat.toFixed(2)}`, 102, yPosition + 5);
    doc.text(`£${legalTotal.toFixed(2)}`, 132, yPosition + 5);

    yPosition += 8;

    // Total row
    doc.setFont('helvetica', 'bold');
    doc.rect(10, yPosition, 60, 8);
    doc.rect(70, yPosition, 30, 8);
    doc.rect(100, yPosition, 30, 8);
    doc.rect(130, yPosition, 40, 8);

    doc.text('TOTAL', 12, yPosition + 5);
    doc.text('', 72, yPosition + 5);
    doc.text('', 102, yPosition + 5);
    doc.text(`£${legalTotal.toFixed(2)}`, 132, yPosition + 5);

    // Additional details
    const finalY = yPosition + 20;
    doc.setFontSize(10);
    doc.text('This quote is valid for 30 days from the date of issue.', 10, finalY);
    doc.text(`Generated on: ${new Date().toLocaleDateString('en-GB')}`, 10, finalY + 10);

    // Footer
    doc.setFontSize(8);
    doc.text('My Law Matters - Professional Legal Services', 10, doc.internal.pageSize.height - 20);

    // Save the PDF
    const filename = `LPA_Quote_${leadData?.lead_id || 'Quote'}.pdf`;
    doc.save(filename);

    Swal.fire('Success', 'Quote downloaded successfully!', 'success');
  };

  const handleDownload = () => {
    generatePDF();
  };

  return (
    <Modal show={show} onHide={onHide} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton style={{ borderBottom: '1px solid #dee2e6' }}>
        <Modal.Title id="contained-modal-title-vcenter">View Quote</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="table-responsive">
          <Table bordered hover style={{ marginBottom: 0 }}>
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                <th style={{ fontWeight: '600', width: '50%' }}>Lasting Powers Of Attorney</th>
                <th style={{ fontWeight: '600', textAlign: 'center' }}>Net</th>
                <th style={{ fontWeight: '600', textAlign: 'center' }}>VAT</th>
                <th style={{ fontWeight: '600', textAlign: 'center' }}>Gross</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Legal Fees</td>
                <td style={{ textAlign: 'center' }}>
                  £{(quoteData?.totals?.total?.net || quoteData?.mlmLegalCost || 0).toFixed(2)}
                </td>
                <td style={{ textAlign: 'center' }}>
                  £{(quoteData?.totals?.total?.vat || quoteData?.vat || 0).toFixed(2)}
                </td>
                <td style={{ textAlign: 'center', fontWeight: '600' }}>
                  £{(quoteData?.totals?.total?.gross || quoteData?.totalCost || 0).toFixed(2)}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>

        <div className="mt-4 text-center">
          <Button
            variant="primary"
            onClick={handleDownload}
            style={{
              minWidth: '120px',
              fontSize: '0.875rem'
            }}
          >
            <i className="fas fa-download me-2"></i>
            Download
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}


// Revise Quote Modal Component
function ReviseQuoteModal({ show, onHide, leadData, authToken, onReviseQuote }) {
  const [legalFees, setLegalFees] = React.useState('');
  const [vat, setVat] = React.useState(0);
  const [gross, setGross] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(false);
  const [currentCalculation, setCurrentCalculation] = React.useState(null);

  // Initialize with latest calculation from database
  React.useEffect(() => {
    const fetchLatestCalculation = async () => {
      if (show && leadData?.lead_id) {
        try {
          console.log('🔍 Fetching latest LPA calculation for:', leadData.lead_id);
          const result = await postRequest('private/getFinalLeadCalculations', {
            lead_id: leadData.lead_id
          }, authToken);

          console.log('📊 API Response:', result);

          if (result.status === 200 && result.data && result.data.length > 0) {
            const latestCalc = result.data[0];
            setCurrentCalculation(latestCalc); // Store the entire calculation
            const currentLegalFees = latestCalc.totals?.total?.net || 0;
            console.log('✅ Latest Legal Fees:', currentLegalFees);
            console.log('✅ Partner/Branch Info:', {
              partner_id: latestCalc.partner_id,
              partner_name: latestCalc.partner_name,
              branch_id: latestCalc.branch_id,
              branch_name: latestCalc.branch_name,
              rate_card_type: latestCalc.rate_card_type
            });
            setLegalFees(currentLegalFees.toString());
            calculateVatAndGross(currentLegalFees);
          } else {
            console.log('⚠️ No calculation found, using leadData');
            // Fallback to leadData if no calculation found
            const currentLegalFees = leadData.mlmLegalCost || 0;
            setLegalFees(currentLegalFees.toString());
            calculateVatAndGross(currentLegalFees);
          }
        } catch (error) {
          console.error('❌ Error fetching latest calculation:', error);
          // Fallback to leadData on error
          const currentLegalFees = leadData.mlmLegalCost || 0;
          setLegalFees(currentLegalFees.toString());
          calculateVatAndGross(currentLegalFees);
        }
      }
    };

    fetchLatestCalculation();
  }, [leadData, show, authToken]);

  // Calculate VAT and Gross when legal fees change
  const handleLegalFeesChange = (e) => {
    const value = e.target.value;
    setLegalFees(value);

    const numValue = parseFloat(value) || 0;
    calculateVatAndGross(numValue);
  };

  const calculateVatAndGross = (legalFeesAmount) => {
    const vatAmount = legalFeesAmount * 0.20; // 20% VAT
    const grossAmount = legalFeesAmount + vatAmount;

    setVat(vatAmount);
    setGross(grossAmount);
  };

  const handleReviseQuote = async () => {
    try {
      setIsLoading(true);
      const numLegalFees = parseFloat(legalFees) || 0;

      if (numLegalFees <= 0) {
        Swal.fire('Error', 'Please enter a valid legal fee amount', 'error');
        return;
      }

      const payload = {
        lead_id: leadData.lead_id,
        mlmLegalCost: numLegalFees,
        vat: vat,
        totalCost: gross,
        // Preserve partner/branch information from current calculation
        partner_id: currentCalculation?.partner_id || null,
        partner_name: currentCalculation?.partner_name || null,
        branch_id: currentCalculation?.branch_id || null,
        branch_name: currentCalculation?.branch_name || null,
        rate_card_type: currentCalculation?.rate_card_type || null
      };

      console.log('📝 Modal submitting revised LPA quote:', payload);

      // Call the onReviseQuote callback
      await onReviseQuote(payload);

      // Close modal
      onHide();

      // Reset form
      setLegalFees('');
      setVat(0);
      setGross(0);
    } catch (error) {
      console.error('❌ Modal error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered className="revise-quote-modal">
      <Modal.Header closeButton style={{ borderBottom: '1px solid #dee2e6' }}>
        <Modal.Title style={{ fontSize: '1.25rem', fontWeight: '600' }}>Revise Quote</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '1.5rem' }}>
        <div className="table-responsive">
          <Table bordered hover style={{ marginBottom: 0 }}>
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                <th style={{
                  fontWeight: '600',
                  fontSize: '0.95rem',
                  padding: '12px 15px',
                  borderRight: '2px solid #dee2e6',
                  width: '40%'
                }}>
                  Lasting Powers Of Attorney <span style={{ color: '#dc3545', fontSize: '1.1rem' }}>+</span>
                </th>
                <th style={{ fontWeight: '600', fontSize: '0.95rem', textAlign: 'center', padding: '12px 15px' }}>Net</th>
                <th style={{ fontWeight: '600', fontSize: '0.95rem', textAlign: 'center', padding: '12px 15px' }}>VAT</th>
                <th style={{ fontWeight: '600', fontSize: '0.95rem', textAlign: 'center', padding: '12px 15px' }}>Gross</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{
                  padding: '12px 15px',
                  fontSize: '0.95rem',
                  borderRight: '2px solid #dee2e6'
                }}>
                  Legal Fees
                </td>
                <td style={{ textAlign: 'center', padding: '10px' }}>
                  <Form.Control
                    type="number"
                    value={legalFees}
                    onChange={handleLegalFeesChange}
                    placeholder="Enter amount"
                    style={{
                      fontSize: '0.95rem',
                      textAlign: 'center',
                      fontWeight: '500'
                    }}
                  />
                </td>
                <td style={{
                  textAlign: 'center',
                  verticalAlign: 'middle',
                  fontSize: '0.95rem',
                  fontWeight: '500',
                  color: '#495057'
                }}>
                  £{vat.toFixed(2)}
                </td>
                <td style={{
                  textAlign: 'center',
                  verticalAlign: 'middle',
                  fontSize: '0.95rem',
                  fontWeight: '600',
                  color: '#28a745'
                }}>
                  £{gross.toFixed(2)}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: '1px solid #dee2e6', padding: '1rem 1.5rem' }}>
        <Button
          variant="secondary"
          onClick={onHide}
          style={{
            paddingLeft: '20px',
            paddingRight: '20px'
          }}
        >
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={handleReviseQuote}
          disabled={isLoading}
          style={{
            paddingLeft: '20px',
            paddingRight: '20px'
          }}
        >
          {isLoading ? 'Saving...' : 'Save Changes'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default function ViewLeadLastingPowersOfAttorney() {
  const [modalShow, setModalShow] = React.useState(false);
  const [showQuoteModal, setShowQuoteModal] = React.useState(false);
  const [reviseModalShow, setReviseModalShow] = React.useState(false);
  const [leadData, setLeadData] = React.useState(null);
  const [contactAttempts, setContactAttempts] = React.useState(leadData?.contact_attempts || 0);
  const [partners, setPartners] = React.useState([]);
  const [lenderPanels, setLenderPanels] = React.useState([]);
  const [quoteData, setQuoteData] = React.useState(null);
  const [quoteSummaryData, setQuoteSummaryData] = React.useState(null);
  const [loadingQuote, setLoadingQuote] = React.useState(false);
  const [quoteHistory, setQuoteHistory] = React.useState([]);
  const navigate = useNavigate();
  const authCtx = React.useContext(AuthContext);

  const{id} = useParams()

  // Wolverhampton branch ID for LPA calculations (default)
  const WOLVERHAMPTON_BRANCH_ID = '68eca54d14a6d7fec7dfc823';

  

  const handleUpdateContactAttempt = async (type) => {
  let updatedCount = contactAttempts;

  if (type === 'increase') updatedCount += 1;
  else if (type === 'reset') updatedCount = 0;

  try {
    const res = await postRequest('private/change-contact-status', {
      lead_id: id,
      contact_attempts: updatedCount,
    }, authCtx.token);

    if (res.status === 200 || res.status === 'success') {
      setContactAttempts(updatedCount);
     // alert('Contact attempts updated successfully!');
    } else {
     // alert('Failed to update contact attempts.');
    }
  } catch (err) {
    console.error('Error:', err);
   // alert('Error updating contact attempts.');
  }
};

const handleDeleteLead = () => {
  Swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!'
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const res = await deleteRequest(`private/delete-lead/${id}`, {}, authCtx.token);
        if (res.status === 200 || res.status === 'success') {
          Swal.fire(
            'Deleted!',
            'The lead has been deleted.',
            'success'
          );
          navigate('/leads');
        } else {
          Swal.fire('Error!', res.message || 'Failed to delete lead.', 'error');
        }
      } catch (err) {
        console.error('Error deleting lead:', err);
        Swal.fire('Error!', 'An error occurred while deleting the lead.', 'error');
      }
    }
  });
};

  const slugify = (text) =>
  text
    ?.toLowerCase()
    ?.replace(/ /g, '-')      // spaces to hyphen
    ?.replace(/[^\w-]+/g, '') // remove special chars
    ?.replace(/-+/g, '-');    // collapse consecutive hyphens to single hyphen

  // Determine if lead should use Individual or Couple rate based on documents
  const determineServiceType = () => {
    if (!leadData?.documents) return 'For Individual';

    const documents = leadData.documents;
    let hasHealthWelfare = false;
    let hasPropertyFinance = false;

    // Handle array of strings format: ["Health & Welfare", "Property & Finance"]
    if (Array.isArray(documents)) {
      hasHealthWelfare = documents.some(doc =>
        typeof doc === 'string' && doc.includes('Health') && doc.includes('Welfare')
      );
      hasPropertyFinance = documents.some(doc =>
        typeof doc === 'string' && doc.includes('Property') && doc.includes('Finance')
      );
    }
    // Handle object format: {health_welfare: true, property_finance: true}
    else if (typeof documents === 'object') {
      hasHealthWelfare = documents.health_welfare === true;
      hasPropertyFinance = documents.property_finance === true;
    }

    // If both documents are present, use "For Couple", otherwise "For Individual"
    return (hasHealthWelfare && hasPropertyFinance) ? 'For Couple' : 'For Individual';
  };

  // 🎯 NEW: Fetch LPA quote detail from final_leads_calculations
  const fetchLpaQuoteDetail = async () => {
    setLoadingQuote(true);
    try {
      console.log('📊 Fetching LPA calculation from final_leads_calculations for lead:', id);

      // Use the unified API endpoint
      const response = await getRequest(`private/getFormattedLeadCalculation/${id}`);

      console.log('✅ LPA Quote Response:', response);

      if (response?.status === 200 && response?.data) {
        console.log('💰 Calculation data:', response.data);

        // Transform data for LPA display
        const transformedData = {
          lead_id: response.data.lead_id,
          service_type: response.data.service_type,
          branch_name: response.data.branch_name,
          fees: response.data.fees || [],
          disbursements: response.data.disbursements || [],
          totals: response.data.totals,
          calculated_at: response.data.calculated_at
        };

        setQuoteData(transformedData);
        console.log('✅ Transformed Quote Data Set:', transformedData);
      } else if (response?.status === 404) {
        console.warn('⚠️ No calculation found for this LPA lead');
        setQuoteData(null);
      }
    } catch (error) {
      console.error('❌ Error fetching LPA quote detail:', error);
    } finally {
      setLoadingQuote(false);
    }
  };

  // 🎯 NEW: Fetch quote data for Quote Summary display from final_leads_calculations
  const fetchQuoteSummaryData = async () => {
    try {
      console.log('📊 Fetching LPA Quote Summary Data from final_leads_calculations for lead:', id);
      const response = await getRequest(`private/getFormattedLeadCalculation/${id}`);
      console.log('📊 Quote Summary API Response:', response);

      if (response?.status === 200 && response?.data) {
        // Transform new structure for display
        const transformedData = {
          mlmLegalCost: response.data.totals?.total?.net || 0,
          vat: response.data.totals?.total?.vat || 0,
          totalCost: response.data.totals?.total?.gross || 0,
          service_type: response.data.service_type,
          rate_card_type: response.data.rate_card_type,
          partner_name: response.data.partner_name,
          branch_name: response.data.branch_name,
          fees: response.data.fees,
          totals: response.data.totals,
          calculated_at: response.data.calculated_at
        };

        console.log('✅ Quote Summary Data (transformed):', transformedData);
        setQuoteSummaryData(transformedData);
      } else if (response?.status === 404) {
        console.warn('⚠️ No calculation found for this LPA lead in final_leads_calculations');
        setQuoteSummaryData(null);
      } else {
        console.error('❌ No data in quote summary response');
      }
    } catch (error) {
      console.error('❌ Error fetching quote summary data:', error);
      console.error('Error details:', error.response || error.message);
    }
  };

  // Fetch quote history from final_leads_calculations
  const fetchQuoteHistory = async () => {
    if (!id) return;

    try {
      const res = await postRequest('private/getFinalLeadCalculations', {
        lead_id: id
      }, authCtx.token);

      if (res.status === 200 && res.data) {
        console.log('✅ Quote History:', res.data);

        // Transform data to match expected format for Quotes tab
        const transformedHistory = res.data.map((calc, index) => ({
          mlmLegalCost: calc.totals?.total?.net || 0,
          vat: calc.totals?.total?.vat || 0,
          totalCost: calc.totals?.total?.gross || 0,
          created_at: calc.createdAt,
          rate_card_type: calc.rate_card_type,
          partner_name: calc.partner_name,
          branch_name: calc.branch_name,
          created_by: calc.created_by || 'User',
          revision_number: res.data.length - index,
          status: calc.is_active ? 'Current' : `Revision ${res.data.length - index}`,
          isCurrent: calc.is_active || false,
          calculation_source: calc.calculation_source
        }));

        console.log('✅ Transformed Quote History:', transformedHistory);
        setQuoteHistory(transformedHistory);
      }
    } catch (err) {
      console.error('❌ Error fetching quote history:', err);
    }
  };

  // View quote detail - open modal with selected quote data
  const handleViewQuoteDetail = (quote) => {
    console.log('Viewing quote details:', quote);
    // Transform quote history data to match the modal's expected format
    const transformedQuoteData = {
      lead_id: id,
      service_type: 'Lasting_Powers_Of_Attorney',
      branch_name: quote.branch_name,
      totals: {
        total: {
          net: quote.mlmLegalCost,
          vat: quote.vat,
          gross: quote.totalCost
        }
      },
      calculated_at: quote.created_at
    };
    setQuoteData(transformedQuoteData);
    setShowQuoteModal(true);
  };

  // Regenerate quote - call backend API to calculate and save
  const handleRegenerateQuote = async () => {
    try {
      const result = await Swal.fire({
        title: 'Regenerate Quote?',
        text: 'This will recalculate the quote using the latest rates and save to database.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, Regenerate',
        cancelButtonText: 'Cancel'
      });

      if (!result.isConfirmed) return;

      setLoadingQuote(true);

      // Call the backend API to calculate and save the quote
      const response = await postRequest(`private/regenerate-lpa-quote/${id}`, {}, authCtx.token);

      if (response?.status === 'success' || response?.status === 200) {
        console.log('✅ Quote regenerated successfully:', response.data);

        // Refresh the calculation data
        await fetchQuoteSummaryData();
        await fetchQuoteHistory();

        Swal.fire('Success!', 'Quote has been regenerated and saved to database.', 'success');
      } else {
        throw new Error(response?.message || 'Failed to regenerate quote');
      }
    } catch (err) {
      console.error('Error regenerating quote:', err);
      Swal.fire('Error!', err.message || 'An error occurred while regenerating the quote.', 'error');
    } finally {
      setLoadingQuote(false);
    }
  };

  // Handle revise quote - called from modal
  const handleReviseQuote = async (payload) => {
    try {
      console.log('🎯 Revising LPA quote with payload:', payload);

      const response = await postRequest(`private/updateLpaQuote/${id}`, payload, authCtx.token);

      if (response?.status === 'success' || response?.status === 200) {
        console.log('✅ LPA Quote revised successfully');

        // Refresh quote data
        await fetchQuoteSummaryData();
        await fetchQuoteHistory();

        Swal.fire('Success!', 'Quote has been revised successfully.', 'success');
      } else {
        throw new Error(response?.message || 'Failed to revise quote');
      }
    } catch (error) {
      console.error('❌ Error revising quote:', error);
      Swal.fire('Error', error.message || 'Failed to revise quote. Please try again.', 'error');
    }
  };


 // const lead_id = "L-10"; // Replace with dynamic id if needed

  const fetchPartners = async () => {
    try {
      const res = await postRequest('private/partnersList', {}, authCtx.token);
      if (res?.status === 200 && res?.data) {
        setPartners(res.data);
      }
    } catch (err) {
      console.error('Error fetching partners:', err);
    }
  };

  const fetchLenderPanels = async () => {
    try {
      const res = await postRequest('private/lenderPanels', {}, authCtx.token);
      if (res?.status === 200 && res?.data) {
        setLenderPanels(res.data);
      } else if (res?.data) {
        setLenderPanels(res.data);
      }
    } catch (err) {
      console.error('Error fetching lender panels:', err);
    }
  };

  React.useEffect(() => {
    async function fetchLead() {
      try {
        const res = await postRequest(`private/lead-overview-data/${id}`, {}, authCtx.token);
        if (res.status === 'success') {
          console.log(res.data , 'lead data fetched successfully');
          setLeadData(res.data);
        }
      } catch (err) {
        console.error("Error fetching lead data", err);
      }
    }

    fetchLead();
    // fetchPartners();
    // fetchLenderPanels();
  }, [id, authCtx.token]);

  // Fetch calculation when leadData is available
  React.useEffect(() => {
    if (leadData) {
      fetchQuoteSummaryData();
    }
  }, [leadData]);

  // Fetch quote history when lead ID is available
  React.useEffect(() => {
    if (id && authCtx.token) {
      fetchQuoteHistory();
    }
  }, [id, authCtx.token]);

  return (
    <>
      <BreadcrumbsWrapper
                   items={[
                   { label: 'Dashboard', path: '/dashboard' },
                   { label: 'Leads', path: '/leads' },
                   { label: 'View Leads', path: '' },
                 
                      ]}
                        />
                       <br></br>
    
      <div className='page-header pb-3'>
        <h1 className='mt-0 mb-0'>
          {leadData ? `${leadData.product_title} #${leadData.lead_id}` : 'Loading...'}
        </h1>
      </div>

      <div className='page-top-formview mb-3'>
        <div className='customer-tab-view leads-tab-view'>
          <Tabs defaultActiveKey="overview" id="uncontrolled-tab-example">
            {/* OVERVIEW */}
            <Tab eventKey="overview" title="Overview">
              <div className='mt-3'>

                {/* ------------------------ Quote Box UI ------------------------ */}
                <div className="card shadow-sm mb-4" style={{ borderRadius: '10px', overflow: 'hidden' }}>
                  <div className="card-header" style={{
                    backgroundColor: '#f8f9fa',
                    borderBottom: '2px solid #e9ecef',
                    padding: '1rem 1.25rem'
                  }}>
                    <h5 className="mb-0" style={{ color: '#495057', fontWeight: '600' }}>
                      Quote Summary
                    </h5>
                  </div>
                  <div className="card-body" style={{ padding: '1.5rem' }}>
                    {loadingQuote ? (
                      <div style={{ textAlign: 'center', padding: '40px' }}>
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : quoteSummaryData ? (
                      <>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <div className="d-flex align-items-baseline gap-3">
                            <span className="text-muted small">Total Cost</span>
                            <span style={{ color: '#2c3e50', fontWeight: '600', fontSize: '1.2rem' }}>
                              £{(quoteSummaryData.mlmLegalCost || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Net + £{(quoteSummaryData.vat || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} VAT = £{(quoteSummaryData.totalCost || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Gross
                            </span>
                          </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            {quoteSummaryData.calculated_at && (
                              <span className="text-muted small">
                                {new Date(quoteSummaryData.calculated_at).toLocaleDateString('en-GB')} {new Date(quoteSummaryData.calculated_at).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
                              </span>
                            )}
                            {quoteSummaryData && (quoteSummaryData.partner_name || quoteSummaryData.branch_name) && (
                              <span className="badge bg-info text-white ms-2">
                                {quoteSummaryData.rate_card_type === 'PARTNER' && quoteSummaryData.partner_name ? (
                                  <>Partner: {quoteSummaryData.partner_name}</>
                                ) : quoteSummaryData.rate_card_type === 'BRANCH' && quoteSummaryData.branch_name ? (
                                  <>Branch: {quoteSummaryData.branch_name}</>
                                ) : null}
                              </span>
                            )}
                            {quoteSummaryData.service_type && (
                              <span className="badge bg-secondary text-white ms-2">
                                {quoteSummaryData.service_type}
                              </span>
                            )}
                          </div>
                          <a href="#" className="text-primary text-decoration-none small" onClick={(e) => {
                            e.preventDefault();
                            console.log('🔍 View Quote Detail clicked from Quote Summary');
                            // Set current quote summary data before opening modal
                            setQuoteData(quoteSummaryData);
                            setShowQuoteModal(true);
                          }}>
                            View Quote Detail
                          </a>
                        </div>
                      </>
                    ) : (
                      <div style={{ textAlign: 'center', padding: '20px' }}>
                        <p className="text-muted mb-0">No quote data available. Please regenerate the quote.</p>
                      </div>
                    )}
                  </div>

                  {/* Action Buttons */}
                  <div className="card-footer bg-light" style={{ borderTop: '1px solid #e9ecef', padding: '1rem 1.25rem' }}>
                    <div className="d-flex gap-2 flex-wrap align-items-center">
                      <Button
                        variant="contained"
                        className='text-capitalize'
                        onClick={() => setReviseModalShow(true)}
                        style={{
                          backgroundColor: '#dc3545',
                          borderColor: '#dc3545',
                          fontSize: '0.875rem',
                          padding: '8px 16px'
                        }}
                      >
                        <EditOutlinedIcon fontSize="small" style={{ marginRight: '6px' }} />
                        Revise Quote
                      </Button>
                      <Button
                        variant="outlined"
                        className='text-capitalize'
                        onClick={handleRegenerateQuote}
                        disabled={loadingQuote}
                        style={{
                          color: '#17a2b8',
                          borderColor: '#17a2b8',
                          fontSize: '0.875rem',
                          padding: '8px 16px'
                        }}
                      >
                        <RefreshIcon fontSize="small" style={{ marginRight: '6px' }} />
                        {loadingQuote ? 'Loading...' : 'Regenerate Quote'}
                      </Button>
                    </div>
                  </div>
                </div>

                {/* ------------------------ End Quote Box ------------------------ */}

                <ul className="list-group mb-3">
                  {leadData?.customers && (
                    <li className="list-group-item">
                      <div className="row">
                        <div className="col-4 fw-bold">Customers</div>
                        <div className="col-8">
                          {(() => {
                            // Handle multiple customers (array)
                            if (Array.isArray(leadData.customers) && leadData.customers.length > 0) {
                              return leadData.customers.map(customer =>
                                `${customer.title || ''} ${customer.forename || ''} ${customer.surname || ''}`.trim()
                              ).join(', ');
                            }
                            // Handle single customer (object)
                            else if (typeof leadData.customers === 'object' && !Array.isArray(leadData.customers)) {
                              return `${leadData.customers.title || ''} ${leadData.customers.forename || ''} ${leadData.customers.surname || ''}`.trim();
                            }
                            // Handle customer_name field (string)
                            else if (leadData?.customer_name) {
                              return leadData.customer_name;
                            }
                            // Fallback
                            else {
                              return leadData.customers;
                            }
                          })()}
                        </div>
                      </div>
                    </li>
                  )}
      {leadData?.documents && (
        <li className="list-group-item">
          <div className="row">
            <div className="col-4 fw-bold">Documents</div>
            <div className="col-8">
              <ul className="mb-0">
                {Array.isArray(leadData.documents)
                  ? leadData.documents.map((doc, index) => {
                      // Handle object format: [{health_welfare: true, property_finance: true}]
                      if (typeof doc === 'object' && doc !== null) {
                        return Object.entries(doc)
                          .filter(([key, value]) => value === true)
                          .map(([key]) => (
                            <li key={`${index}-${key}`}>
                              {key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                            </li>
                          ));
                      }
                      // Handle string format: ["Health & Welfare", "Property & Finance"]
                      return <li key={index}>{doc}</li>;
                    })
                  : typeof leadData.documents === 'object'
                  ? Object.entries(leadData.documents)
                      .filter(([key, value]) => value === true)
                      .map(([key]) => (
                        <li key={key}>
                          {key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                        </li>
                      ))
                  : <li>{String(leadData.documents)}</li>
                }
              </ul>
            </div>
          </div>
        </li>
      )}


                  {/* <li className="list-group-item">
                    <div className="row">
                      <div className="col-4 fw-bold">Group Code</div>
                      <div className="col-8">{leadData?.group_code_code}</div>
                    </div>
                  </li> */}
                  <li className="list-group-item">
                    <div className="row">
                      <div className="col-4 fw-bold">Status</div>
                      <div className="col-8">{leadData?.status}</div>
                    </div>
                  </li>
                  {/* <li className="list-group-item">
                    <div className="row">
                      <div className="col-4 fw-bold">Complexity</div>
                      <div className="col-8">None</div>
                    </div>
                  </li> */}
                  {leadData?.lender_panel_id && (
                    <li className="list-group-item">
                      <div className="row">
                        <div className="col-4 fw-bold">Lender Panel</div>
                        <div className="col-8">
                          {(() => {
                            const lenderPanelId = typeof leadData.lender_panel_id === 'object'
                              ? leadData.lender_panel_id._id || leadData.lender_panel_id.$oid
                              : leadData.lender_panel_id;

                            // Try to find lender panel from fetched list
                            const lenderPanel = lenderPanels.find(lp => lp._id === lenderPanelId);

                            if (lenderPanel) {
                              return (
                                <div>
                                  <div>
                                    <span className="badge bg-info">
                                      {lenderPanel.name || lenderPanel.title}
                                    </span>
                                  </div>
                                  {lenderPanel?.lender_numbers && lenderPanel.lender_numbers.length > 0 && (
                                    <div style={{ color: '#6c757d', fontSize: '0.875rem', marginTop: '0.5rem' }}>
                                      <span style={{ fontWeight: '500' }}>Lender Panel Number: </span>
                                      {lenderPanel.lender_numbers.join(', ')}
                                    </div>
                                  )}
                                </div>
                              );
                            }

                            // If lender panel is already populated in leadData
                            if (leadData.lender_panel_id && typeof leadData.lender_panel_id === 'object' && leadData.lender_panel_id.name) {
                              return (
                                <div>
                                  <div>
                                    <span className="badge bg-info">
                                      {leadData.lender_panel_id.name}
                                    </span>
                                  </div>
                                  {leadData.lender_panel_id?.lender_numbers && leadData.lender_panel_id.lender_numbers.length > 0 && (
                                    <div style={{ color: '#6c757d', fontSize: '0.875rem', marginTop: '0.5rem' }}>
                                      <span style={{ fontWeight: '500' }}>Lender Panel Number: </span>
                                      {leadData.lender_panel_id.lender_numbers.join(', ')}
                                    </div>
                                  )}
                                </div>
                              );
                            }

                            return <span className="text-muted">Lender Panel ID: {lenderPanelId || 'Unknown'}</span>;
                          })()}
                        </div>
                      </div>
                    </li>
                  )}
                  {leadData?.partner_id && (
                    <li className="list-group-item">
                      <div className="row">
                        <div className="col-4 fw-bold">Partner</div>
                        <div className="col-8">
                          {(() => {
                            const partnerId = typeof leadData.partner_id === 'object' ? leadData.partner_id._id : leadData.partner_id;
                            const partner = partners.find(p => p._id === partnerId);
                            if (partner) {
                              return partner.name;
                            }
                            return <span className="text-muted">Not specified</span>;
                          })()}
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
              <Row className='m-0'>
                <Stack spacing={2} direction="row" style={{ justifyContent: 'space-between', padding: 0 }}>
                  <Button variant="outlined" className='red-outline-btn text-capitalize'>
                  <NavLink
                  to={`/leads/${slugify(leadData?.product_title)}/edit/${leadData?.product_id}/${leadData?.lead_id}`}
                  className="red-link-text"
                >
                  <EditOutlinedIcon /> &nbsp; Edit
                </NavLink>

                  </Button>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span className="me-3">
                      Created: {leadData ? new Date(leadData.created_at).toLocaleDateString() + `- ${leadData.created_by}` : 'Loading...'}
                    </span>
                    <Dropdown className='mb-0 ps-0 '>
                      <Dropdown.Toggle className='dropdown-border-btn red-outline-btn text-capitalize'>
                        More Action
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item>
                          <Link to="/leads/changestatus" state={{ id: id , title:slugify(leadData?.product_title) }} >
                                  Change Status
                                </Link>
                        </Dropdown.Item>
                        <Dropdown.Item><Link to="/leads/changegroupcode" state={{ id: id , title:slugify(leadData?.product_title) }}>Change Group Code</Link></Dropdown.Item>
                        <Dropdown.Item onClick={handleDeleteLead}>Delete Lead</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </Stack>
              </Row>
            </Tab>

            {/* QUOTES */}
            <Tab eventKey="quotes" title="Quotes">
              <div className="mt-3">
                {(() => {
                  // Use quote history from final_leads_calculations (already includes current quote)
                  const allQuotes = quoteHistory && quoteHistory.length > 0 ? quoteHistory : [];

                  console.log('🎯 All LPA quotes to display:', allQuotes);

                  if (allQuotes.length === 0) {
                    return (
                      <div className="text-center py-5">
                        <i className="fas fa-file-invoice fa-3x text-muted mb-3"></i>
                        <h5 className="text-muted">No Quotes Available</h5>
                        <p className="text-muted">No quotes have been generated yet.</p>
                      </div>
                    );
                  }

                  return (
                    <div className="quote-history-section">
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c3e50' }}>
                          <i className="fas fa-history me-2" style={{ color: '#3498db' }}></i>
                          Quote History
                        </h5>
                        <span className="badge bg-primary" style={{ fontSize: '0.9rem', padding: '6px 12px' }}>
                          {allQuotes.length} {allQuotes.length === 1 ? 'Version' : 'Versions'}
                        </span>
                      </div>

                      <div style={{ position: 'relative', paddingLeft: '30px' }}>
                        {/* Timeline line */}
                        <div style={{
                          position: 'absolute',
                          left: '13px',
                          top: '20px',
                          bottom: '20px',
                          width: '2px',
                          background: 'linear-gradient(to bottom, #3498db, #95a5a6)',
                        }}></div>

                        {allQuotes.map((quote, index) => {
                          const isActive = quote.isCurrent;
                          const versionLabel = isActive ? 'Current' : (quote.revision_number > 0 ? `Revision ${quote.revision_number}` : 'Original');

                          return (
                            <div key={index} style={{ position: 'relative', marginBottom: '24px' }}>
                              {/* Timeline dot */}
                              <div style={{
                                position: 'absolute',
                                left: '-26px',
                                top: '16px',
                                width: '16px',
                                height: '16px',
                                borderRadius: '50%',
                                backgroundColor: isActive ? '#27ae60' : '#95a5a6',
                                border: '3px solid white',
                                boxShadow: isActive ? '0 0 0 2px #27ae60' : '0 0 0 2px #95a5a6',
                                zIndex: 1
                              }}></div>

                              {/* Card */}
                              <div className="card" style={{
                                border: `2px solid ${isActive ? '#27ae60' : '#e9ecef'}`,
                                borderRadius: '12px',
                                boxShadow: isActive ? '0 4px 12px rgba(39, 174, 96, 0.15)' : '0 2px 8px rgba(0,0,0,0.08)',
                                transition: 'all 0.3s ease',
                                backgroundColor: isActive ? '#f8fff9' : 'white'
                              }}>
                                <div className="card-body" style={{ padding: '20px' }}>
                                  <div className="d-flex justify-content-between align-items-start mb-3">
                                    {/* Left: Version & Amount */}
                                    <div className="flex-grow-1">
                                      <div className="d-flex align-items-center gap-2 mb-2">
                                        <i className={`fas ${isActive ? 'fa-check-circle' : 'fa-file-invoice'}`} style={{ color: isActive ? '#27ae60' : '#95a5a6', fontSize: '18px' }}></i>
                                        <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c3e50' }}>
                                          {versionLabel}
                                        </h5>
                                        {isActive && (
                                          <span className="badge" style={{
                                            backgroundColor: '#27ae60',
                                            color: 'white',
                                            padding: '4px 10px',
                                            borderRadius: '6px',
                                            fontSize: '0.75rem',
                                            fontWeight: 600
                                          }}>
                                            CURRENT
                                          </span>
                                        )}
                                      </div>

                                      {/* Date & Time */}
                                      <p className="text-muted mb-2" style={{ fontSize: '0.85rem' }}>
                                        <i className="far fa-clock me-1"></i>
                                        {new Date(quote.created_at).toLocaleDateString('en-GB', {
                                          day: '2-digit',
                                          month: 'short',
                                          year: 'numeric'
                                        })} at {new Date(quote.created_at).toLocaleTimeString('en-GB', {
                                          hour: '2-digit',
                                          minute: '2-digit'
                                        })}
                                      </p>

                                      {/* Source Badge */}
                                      <span className="badge" style={{
                                        backgroundColor: '#95a5a6',
                                        color: 'white',
                                        padding: '4px 8px',
                                        borderRadius: '4px',
                                        fontSize: '0.7rem'
                                      }}>
                                        {quote.isCurrent ? 'CURRENT QUOTE' : 'HISTORICAL'}
                                      </span>
                                    </div>

                                    {/* Right: Partner/Branch & Action */}
                                    <div className="d-flex flex-column align-items-end gap-2">
                                      {(quote.partner_name || quote.branch_name) && (
                                        <span className="badge bg-info text-white" style={{
                                          padding: '6px 12px',
                                          borderRadius: '6px',
                                          fontSize: '0.75rem',
                                          fontWeight: 600
                                        }}>
                                          {quote.rate_card_type === 'PARTNER' && quote.partner_name ? (
                                            <>
                                              <i className="fas fa-handshake me-1"></i>
                                              Partner: {quote.partner_name}
                                            </>
                                          ) : quote.rate_card_type === 'BRANCH' && quote.branch_name ? (
                                            <>
                                              <i className="fas fa-building me-1"></i>
                                              Branch: {quote.branch_name}
                                            </>
                                          ) : null}
                                        </span>
                                      )}
                                      <Button
                                        variant="outline-primary"
                                        size="sm"
                                        style={{
                                          borderRadius: '8px',
                                          padding: '6px 16px',
                                          fontSize: '0.8rem',
                                          fontWeight: 500,
                                          borderWidth: '2px'
                                        }}
                                        onClick={() => handleViewQuoteDetail(quote)}
                                      >
                                        <i className="fas fa-eye me-1" style={{ fontSize: '14px' }}></i>
                                        VIEW DETAILS
                                      </Button>
                                    </div>
                                  </div>

                                  {/* Pricing Breakdown */}
                                  <div className="mt-3 pt-3" style={{ borderTop: '1px solid #e9ecef' }}>
                                    <div className="row g-3">
                                      {/* Total Amount - Highlighted */}
                                      <div className="col-md-4">
                                        <div style={{
                                          backgroundColor: isActive ? '#e8f5e9' : '#f8f9fa',
                                          padding: '12px',
                                          borderRadius: '8px',
                                          textAlign: 'center'
                                        }}>
                                          <p className="text-muted mb-1" style={{ fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase' }}>
                                            Total Amount
                                          </p>
                                          <h4 className="mb-0" style={{ color: isActive ? '#27ae60' : '#2c3e50', fontWeight: 700 }}>
                                            £{Number(quote.totalCost).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                          </h4>
                                        </div>
                                      </div>

                                      {/* Legal Costs */}
                                      <div className="col-md-4">
                                        <div style={{ padding: '12px' }}>
                                          <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>
                                            <i className="fas fa-balance-scale me-1"></i>
                                            Legal Costs
                                          </p>
                                          <h6 className="mb-0" style={{ color: '#2c3e50', fontWeight: 600 }}>
                                            £{Number(quote.mlmLegalCost).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                          </h6>
                                        </div>
                                      </div>

                                      {/* VAT */}
                                      <div className="col-md-4">
                                        <div style={{ padding: '12px' }}>
                                          <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>
                                            <i className="fas fa-receipt me-1"></i>
                                            VAT Included
                                          </p>
                                          <h6 className="mb-0" style={{ color: '#2c3e50', fontWeight: 600 }}>
                                            £{Number(quote.vat).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                          </h6>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })()}
              </div>
            </Tab>

            {/* NOTES */}
            <Tab eventKey="notes" title="Notes">
              <Notes lead_id={id} product_id= {leadData?.product_id}/>
            </Tab>

            {/* COMMUNICATION */}
            {/* <Tab eventKey="communication" title="Communication">
              <div className='communication-table'>
                <Table striped responsive bordered>
                  <thead>
                    <tr>
                      <th>Sent</th>
                      <th>Customer</th>
                      <th>Content</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><MailOutlineIcon /> &nbsp; 04/07/2025 01:00</td>
                      <td>Jack Doe</td>
                      <td>Local Authority, Water & Drainage, Environmental Search <ExitToAppIcon /></td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Tab> */}
            <Tab eventKey="communication" title="Communication">
  <div className='communication-table'>
    <Dropdown>
      <Dropdown.Toggle variant="secondary" id="dropdown-basic">
        Contact Attempt ({contactAttempts})
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => handleUpdateContactAttempt('increase')}>
          <MailOutlineIcon fontSize="small" /> &nbsp; Increase Contact Attempt Count
        </Dropdown.Item>
        <Dropdown.Item onClick={() => handleUpdateContactAttempt('reset')}>
          <CallOutlinedIcon fontSize="small" /> &nbsp; Reset
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  </div>
</Tab>


            {/* APPOINTMENT / TASKS */}
            <Tab eventKey="appointment" title="Tasks">
              <div className='mt-4'>
                <div className="alert alert-info" role="alert">
                  <i className="fas fa-info-circle me-2"></i>
                  No tasks available for this lead.
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>

      <MyVerticallyCenteredModal
        show={showQuoteModal}
        onHide={() => setShowQuoteModal(false)}
        quoteData={quoteData}
        leadData={leadData}
      />

      <ReviseQuoteModal
        show={reviseModalShow}
        onHide={() => setReviseModalShow(false)}
        leadData={leadData}
        authToken={authCtx.token}
        onReviseQuote={handleReviseQuote}
      />
    </>
  );
}
